// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__We7Xv","left":"styles_left__1iU0H"};